import { useState, useRef } from 'react';
import HeroSection from '@/components/HeroSection';
import AutomationGenerator from '@/components/AutomationGenerator';
import WorkflowTemplates from '@/components/WorkflowTemplates';
import { Toaster } from '@/components/ui/sonner';
import { Button } from '@/components/ui/button';
import { ArrowUp, LayoutTemplate, Zap } from 'lucide-react';

const Index = () => {
  const [showGenerator, setShowGenerator] = useState(false);
  const [showTemplates, setShowTemplates] = useState(false);
  const [promptFromTemplate, setPromptFromTemplate] = useState('');
  const generatorRef = useRef<HTMLDivElement>(null);
  const templatesRef = useRef<HTMLDivElement>(null);

  const handleGetStarted = () => {
    setShowGenerator(true);
    setTimeout(() => {
      generatorRef.current?.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }, 100);
  };

  const handleViewTemplates = () => {
    setShowTemplates(true);
    setTimeout(() => {
      templatesRef.current?.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }, 100);
  };

  const handleSelectTemplate = (prompt: string) => {
    setPromptFromTemplate(prompt);
    setShowGenerator(true);
    setTimeout(() => {
      generatorRef.current?.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }, 100);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  return (
    <div className="min-h-screen">
      <HeroSection onGetStarted={handleGetStarted} />
      
      {/* Templates Section */}
      {showTemplates && (
        <div ref={templatesRef} className="py-20 px-6 bg-white dark:bg-gray-950">
          <div className="container mx-auto">
            <WorkflowTemplates onSelectTemplate={handleSelectTemplate} />
            
            <div className="flex justify-center mt-12">
              <Button 
                onClick={handleGetStarted}
                className="btn-gradient text-white px-8 py-3 h-12 text-base font-medium"
              >
                <Zap className="w-4 h-4 mr-2" />
                Create Custom Automation
              </Button>
            </div>
          </div>
        </div>
      )}
      
      {/* Generator Section */}
      {showGenerator && (
        <div ref={generatorRef} className="py-20 px-6 bg-slate-50 dark:bg-slate-900">
          <div className="container mx-auto">
            <AutomationGenerator key={promptFromTemplate} initialPrompt={promptFromTemplate} />
            
            {!showTemplates && (
              <div className="flex justify-center mt-12">
                <Button 
                  onClick={handleViewTemplates}
                  variant="outline"
                  className="px-8 py-3 h-12 text-base font-medium"
                >
                  <LayoutTemplate className="w-4 h-4 mr-2" />
                  Browse Templates
                </Button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Floating Action Button */}
      {(showGenerator || showTemplates) && (
        <Button
          onClick={scrollToTop}
          className="fixed bottom-6 right-6 rounded-full w-12 h-12 p-0 btn-gradient text-white shadow-lg hover:shadow-xl transition-all duration-200 z-50"
          aria-label="Scroll to top"
        >
          <ArrowUp className="w-5 h-5" />
        </Button>
      )}
      
      <Toaster position="top-right" />
    </div>
  );
};

export default Index;